import billService from "../services/billService"

export const GET_BILL_LIST = "GET_BILL_LIST"
export const GET_BILL_LIST_SUCCESS = "GET_BILL_LIST_SUCCESS"
export const GET_BILL_LIST_ERROR = "GET_BILL_LIST_ERROR"
export const GET_BILL_LIST_RESET = "GET_BILL_LIST_RESET"

export const GET_RETURN_BILL_LIST = "GET_RETURN_BILL_LIST"
export const GET_RETURN_BILL_LIST_SUCCESS = "GET_RETURN_BILL_LIST_SUCCESS"
export const GET_RETURN_BILL_LIST_ERROR = "GET_RETURN_BILL_LIST_ERROR"
export const GET_RETURN_BILL_LIST_RESET = "GET_RETURN_BILL_LIST_RESET"

export function getBillListRecord(query) {
    return async (dispatch) => {
        dispatch(getBillList())
        return await billService
            .getBillList(query)
            .then((response) => dispatch(getBillListSuccess(response.data)))
            .catch((error) => dispatch(getBillListError(error)))
    }
}

export function getBillList() {
    return {
        type: GET_BILL_LIST,
    }
}

export function getBillListSuccess(success) {
    return {
        type: GET_BILL_LIST_SUCCESS,
        payload: { success },
    }
}

export function getBillListError(error) {
    return {
        type: GET_BILL_LIST_ERROR,
        payload: { error },
    }
}

export function getBillListReset() {
    return {
        type: GET_BILL_LIST_RESET,
    }
}

export function getReturnBillListRecord(query) {
    return async (dispatch) => {
        dispatch(getReturnBillList())
        return await billService
            .getReturnBillList(query)
            .then((response) => dispatch(getReturnBillListSuccess(response.data)))
            .catch((error) => dispatch(getReturnBillListError(error)))
    }
}

export function getReturnBillList() {
    return {
        type: GET_RETURN_BILL_LIST,
    }
}

export function getReturnBillListSuccess(success) {
    return {
        type: GET_RETURN_BILL_LIST_SUCCESS,
        payload: { success },
    }
}

export function getReturnBillListError(error) {
    return {
        type: GET_RETURN_BILL_LIST_ERROR,
        payload: { error },
    }
}

export function getReturnBillListReset() {
    return {
        type: GET_RETURN_BILL_LIST_RESET,
    }
}